import styled from 'styled-components'

export const Modal = styled.div`
  & div[class^='Modalstyled__Modal'] {
    @media (max-width: 767px) {
      width: 290px;
    }
  }

  & div[class^='Headerstyled__Header'] {
    @media (max-width: 767px) {
      padding: 2rem;
    }
  }

  & div[class^='Contentstyled__Content'] {
    @media (max-width: 767px) {
      padding: 2rem;
    }
  }
`

export const Phone = styled.div`
  font-weight: 700;
`

export const Header = styled.div`
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 2.4rem;
  line-height: 3rem;
  font-weight: 400;
`

export const Text = styled.div`
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #292e3d;
`
